import { UsuarioI } from "./usuario.interface";

export class histActUsuarioI{
  id:BigInteger;
  usuario:UsuarioI;
  fecha:string;
  accion:String;
  novedad:String;
  observacion:String;
  usuarioMod:String;
}
